import Resources from "../../shared/actions/resourcesActions";

export class ProjectSetupsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "project_setup", "/api/v1/project_setups");
  }
}

export default ProjectSetupsResource;
